import { render } from "./MobileAppSidebar.vue?vue&type=template&id=027fb5f6&scoped=true"
import script from "./MobileAppSidebar.vue?vue&type=script&lang=js"
export * from "./MobileAppSidebar.vue?vue&type=script&lang=js"

import "./MobileAppSidebar.vue?vue&type=style&index=0&id=027fb5f6&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027fb5f6"]])

export default __exports__